export default ({
  namespaced: true,
  state: {
    view: 'access',
    // type: 'index',
    value: {permissions: []}
  },
  getters: {
    value: state => {
      return state.value
    },
    permissions: state => {
      return state.value.permissions
    }
  },
  mutations: {
    change_value (state, payload) {
      Object.assign(state.value, payload)
    },
    change_permissions (state, payload) {
      Object.assign(state.value.permissions, payload)
    },
    reset_value (state) {
      Object.assign(state.value, {
        company_id: '',
        created_at: '',
        description: '',
        id: '',
        id_text: '',
        permissions: [],
        updated_at: ''
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/access.js